module.exports = __webpack_public_path__ + "static/media/flat_doorstep.314282d5.png";